import _toConsumableArray from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.some.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = ["src"];
import { GLOBAL_DATA } from '@/component-create/utils/global-enum';
import { ElNotification } from 'element-plus';
import 'element-plus/es/components/notification/style/css'

import { FORM_ITEM } from '../form/enums';
import global from '@/component-create/utils/global';
import { log } from '@/component-create/utils/log';
import XSelect from '../x-select/XSelect.vue';
import { Plus } from '@element-plus/icons-vue';

import { ref, toRefs, onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XForm',
  props: {
    items: {},
    elFormProps: {
      default: function _default() {
        return {};
      }
    },
    saveUrl: {},
    loadUrl: {},
    loaded: {
      type: Boolean
    },
    saveMethods: {},
    handler: {},
    getInstance: {}
  },
  setup: function setup(__props) {
    var _prop$getInstance;
    var prop = __props;
    var formData = ref({});
    var elFormRef = ref();
    var _toRefs = toRefs(prop),
      items = _toRefs.items,
      elFormProps = _toRefs.elFormProps,
      saveUrl = _toRefs.saveUrl,
      loadUrl = _toRefs.loadUrl,
      saveMethods = _toRefs.saveMethods;
    var SAVE = global.globalVal[GLOBAL_DATA.FORM_REQUEST_SAVE];
    var LOAD = global.globalVal[GLOBAL_DATA.FORM_REQUEST_LOAD];
    var loading = ref(false);
    var instance = new Proxy({}, {});
    var hideKey = ref([]);
    var defaultValue = ref({});
    var customSaveParams = ref({});
    (_prop$getInstance = prop.getInstance) === null || _prop$getInstance === void 0 || _prop$getInstance.call(prop, instance);
    instance.setFormData = setFormData;
    instance.getFormData = getFormData;
    instance.getFormDataNotValidate = getFormDataNotValidate;
    instance.save = save;
    instance.load = load;
    instance.showLoading = showLoading;
    instance.closeLoading = closeLoading;
    instance.updateFormData = updateFormData;
    instance.hideFormItemByKey = hideFormItemByKey;
    instance.showFormItemByKey = showFormItemByKey;
    instance.reset = reset;
    instance.setSaveParams = setSaveParams;
    onMounted(function () {
      instance.elFormInstance = elFormRef.value;
      defaultValue.value = _objectSpread({}, formData.value);
    });
    /**
     * 构造虚拟下拉框的选项
     */
    function getVirtualizedSelectOptions(options, labelKey, valueKey) {
      return options.map(function (item) {
        return {
          label: item[labelKey],
          value: item[valueKey]
        };
      });
    }
    /**
     * 上传
     */
    function _beforeUpload(file, key) {
      if (file.type.includes('image')) {
        var blob = new Blob([file]);
        formData.value[key] = URL.createObjectURL(blob);
      } else {
        ElNotification({
          type: 'error',
          title: '错误',
          message: '仅支持图片上传'
        });
      }
      return false;
    }
    /**
     * 设置表单数据
     */
    function setFormData(data) {
      formData.value = data;
    }
    function setSaveParams(data) {
      customSaveParams.value = data;
    }
    /**
     * 重置表单
     */
    function reset() {
      formData.value = _objectSpread({}, defaultValue.value);
    }
    /**
     * 更新表单数据
     */
    function updateFormData(data) {
      formData.value = _objectSpread(_objectSpread({}, formData.value), data);
    }
    /**
     * 获取表单数据
     */
    function getFormData() {
      return new Promise(function (resolve, reject) {
        if (!elFormRef.value) {
          log('XForm', '表单实例未找到', 'error');
          reject('表单实例未找到');
        } else {
          elFormRef.value.validate(function (valid) {
            if (valid) {
              resolve(formData.value);
            } else {
              reject('校验未通过');
            }
          });
        }
      });
    }
    /**
     * 获取表单数据，不校验
     */
    function getFormDataNotValidate() {
      return formData.value;
    }
    /**
     * 保存
     */
    function save(success, error, validateFail) {
      if (!(saveUrl !== null && saveUrl !== void 0 && saveUrl.value)) {
        log('XForm', '未配置API地址', 'error');
        return;
      }
      if (SAVE) {
        getFormData().then(function () {
          showLoading();
          SAVE(saveUrl.value, _objectSpread(_objectSpread({}, customSaveParams.value || {}), formData.value), (saveMethods === null || saveMethods === void 0 ? void 0 : saveMethods.value) || 'post').then(function () {
            ElNotification({
              title: '成功',
              type: 'success',
              message: '保存成功'
            });
            closeLoading();
            success === null || success === void 0 || success(formData.value);
          }).catch(function () {
            // ElNotification({
            //   title: '失败',
            //   type: 'error',
            //   message: '保存失败'
            // })
            closeLoading();
            error === null || error === void 0 || error();
          });
        }).catch(function (error) {
          validateFail === null || validateFail === void 0 || validateFail();
        });
      } else {
        log('XForm', '保存失败，未配置表单保存服务接口：' + GLOBAL_DATA.FORM_REQUEST_SAVE, 'error');
      }
    }
    /**
     * 隐藏表单项
     */
    function hideFormItemByKey(key) {
      if (typeof key === 'string') {
        hideKey.value.push(key);
        if (formData.value[key] !== undefined) {
          formData.value[key] = undefined;
        }
      } else {
        var _hideKey$value;
        (_hideKey$value = hideKey.value).push.apply(_hideKey$value, _toConsumableArray(key));
        key.forEach(function (k) {
          if (formData.value[k] !== undefined) {
            formData.value[k] = undefined;
          }
        });
      }
      hideKey.value = _toConsumableArray(new Set(hideKey.value));
    }
    /**
     * 显示表单项
     */
    function showFormItemByKey(key) {
      if (typeof key === 'string') {
        var i = hideKey.value.findIndex(function (hkey) {
          return hkey === key;
        });
        if (i > -1) {
          hideKey.value.splice(i, 1);
        }
      } else {
        key.forEach(function (k) {
          var i = hideKey.value.findIndex(function (hkey) {
            return hkey === k;
          });
          if (i > -1) {
            hideKey.value.splice(i, 1);
          }
        });
      }
      hideKey.value = _toConsumableArray(hideKey.value);
    }
    function load(data) {
      return new Promise(function (resolve, reject) {
        if (loadUrl !== null && loadUrl !== void 0 && loadUrl.value) {
          showLoading();
          LOAD(loadUrl.value, data).then(function (res) {
            formData.value = res.data;
            closeLoading();
            resolve(res.data);
          }).catch(function () {
            closeLoading();
            reject(false);
          });
        } else {
          reject(false);
        }
      });
    }
    function renderCustomItem(fn) {
      return fn(formData);
    }
    function showLoading() {
      loading.value = true;
    }
    function closeLoading() {
      loading.value = false;
    }
    return function (_ctx, _cache) {
      var _component_el_form_item = _resolveComponent("el-form-item");
      var _component_el_col = _resolveComponent("el-col");
      var _component_el_input = _resolveComponent("el-input");
      var _component_el_option = _resolveComponent("el-option");
      var _component_el_select = _resolveComponent("el-select");
      var _component_el_autocomplete = _resolveComponent("el-autocomplete");
      var _component_el_cascader = _resolveComponent("el-cascader");
      var _component_el_checkbox = _resolveComponent("el-checkbox");
      var _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      var _component_el_color_picker = _resolveComponent("el-color-picker");
      var _component_el_date_picker = _resolveComponent("el-date-picker");
      var _component_el_input_number = _resolveComponent("el-input-number");
      var _component_el_radio = _resolveComponent("el-radio");
      var _component_el_radio_group = _resolveComponent("el-radio-group");
      var _component_el_radio_button = _resolveComponent("el-radio-button");
      var _component_el_rate = _resolveComponent("el-rate");
      var _component_el_select_v2 = _resolveComponent("el-select-v2");
      var _component_el_slider = _resolveComponent("el-slider");
      var _component_el_switch = _resolveComponent("el-switch");
      var _component_el_time_picker = _resolveComponent("el-time-picker");
      var _component_el_time_select = _resolveComponent("el-time-select");
      var _component_el_transfer = _resolveComponent("el-transfer");
      var _component_el_icon = _resolveComponent("el-icon");
      var _component_el_upload = _resolveComponent("el-upload");
      var _component_el_row = _resolveComponent("el-row");
      var _component_el_form = _resolveComponent("el-form");
      var _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createBlock(_component_el_form, _mergeProps(_unref(elFormProps), {
        model: _unref(formData),
        ref_key: "elFormRef",
        ref: elFormRef
      }), {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), function (item, index) {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: index
            }, [item.length > 0 && item.some(function (col) {
              return col && (!col.key || !_unref(hideKey).includes(col.key));
            }) ? (_openBlock(), _createBlock(_component_el_row, {
              key: 0,
              gutter: 20
            }, {
              default: _withCtx(function () {
                return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, function (elItem, i) {
                  return _openBlock(), _createElementBlock(_Fragment, {
                    key: i
                  }, [!elItem ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 0,
                    span: 24 / item.length
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_form_item)];
                    }),
                    _: 2
                  }, 1032, ["span"])) : !_unref(hideKey).includes(elItem.key) ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 1,
                    span: 24 / item.length
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_form_item, {
                        label: elItem.label,
                        prop: elItem.key
                      }, {
                        default: _withCtx(function () {
                          return [elItem.el === _unref(FORM_ITEM).INPUT ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                            key: 0,
                            class: "full",
                            modelValue: _unref(formData)[elItem.key],
                            "onUpdate:modelValue": function onUpdateModelValue($event) {
                              return _unref(formData)[elItem.key] = $event;
                            },
                            ref_for: true
                          }, _objectSpread({
                            placeholder: '请输入' + elItem.label
                          }, elItem.props || {})), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).EL_SELECT ? (_openBlock(), _createBlock(_component_el_select, _mergeProps({
                            key: 1,
                            modelValue: _unref(formData)[elItem.key],
                            "onUpdate:modelValue": function onUpdateModelValue($event) {
                              return _unref(formData)[elItem.key] = $event;
                            },
                            class: "full",
                            ref_for: true
                          }, _objectSpread({
                            placeholder: '请选择' + elItem.label
                          }, elItem.props || {})), {
                            default: _withCtx(function () {
                              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elItem.options || [], function (option) {
                                return _openBlock(), _createBlock(_component_el_option, {
                                  key: option[elItem.labelKey || 'value'],
                                  label: option[elItem.labelKey || 'label'],
                                  value: option[elItem.valueKey || 'value']
                                }, null, 8, ["label", "value"]);
                              }), 128))];
                            }),
                            _: 2
                          }, 1040, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).SELECT ? (_openBlock(), _createBlock(XSelect, _mergeProps({
                            key: 2,
                            modelValue: _unref(formData)[elItem.key],
                            "onUpdate:modelValue": function onUpdateModelValue($event) {
                              return _unref(formData)[elItem.key] = $event;
                            },
                            class: "full",
                            ref_for: true
                          }, _objectSpread({
                            placeholder: '请选择' + elItem.label
                          }, elItem.props || {})), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).AUTOCOMPLETE ? (_openBlock(), _createBlock(_component_el_autocomplete, _mergeProps({
                            key: 3,
                            class: "full",
                            modelValue: _unref(formData)[elItem.key],
                            "onUpdate:modelValue": function onUpdateModelValue($event) {
                              return _unref(formData)[elItem.key] = $event;
                            },
                            ref_for: true
                          }, _objectSpread({
                            placeholder: '请输入' + elItem.label
                          }, elItem.props || {})), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).CASCADER ? (_openBlock(), _createBlock(_component_el_cascader, _mergeProps({
                            key: 4,
                            class: "full",
                            modelValue: _unref(formData)[elItem.key],
                            "onUpdate:modelValue": function onUpdateModelValue($event) {
                              return _unref(formData)[elItem.key] = $event;
                            },
                            ref_for: true
                          }, _objectSpread({
                            placeholder: '请选择' + elItem.label
                          }, elItem.props || {})), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).CHECKBOX ? (_openBlock(), _createBlock(_component_el_checkbox_group, _mergeProps({
                            key: 5,
                            modelValue: _unref(formData)[elItem.key],
                            "onUpdate:modelValue": function onUpdateModelValue($event) {
                              return _unref(formData)[elItem.key] = $event;
                            },
                            ref_for: true
                          }, elItem.props || {}), {
                            default: _withCtx(function () {
                              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elItem.options || [], function (option) {
                                return _openBlock(), _createBlock(_component_el_checkbox, {
                                  key: option[elItem.labelKey || 'value'],
                                  label: option[elItem.valueKey || 'value']
                                }, {
                                  default: _withCtx(function () {
                                    return [_createTextVNode(_toDisplayString(option[elItem.labelKey || 'label']), 1)];
                                  }),
                                  _: 2
                                }, 1032, ["label"]);
                              }), 128))];
                            }),
                            _: 2
                          }, 1040, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).COLOR_PICKER ? (_openBlock(), _createBlock(_component_el_color_picker, _mergeProps({
                            key: 6,
                            modelValue: _unref(formData)[elItem.key],
                            "onUpdate:modelValue": function onUpdateModelValue($event) {
                              return _unref(formData)[elItem.key] = $event;
                            },
                            ref_for: true
                          }, elItem.props || {}), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).DATE_PICKER ? (_openBlock(), _createBlock(_component_el_date_picker, _mergeProps({
                            key: 7,
                            class: "full",
                            modelValue: _unref(formData)[elItem.key],
                            "onUpdate:modelValue": function onUpdateModelValue($event) {
                              return _unref(formData)[elItem.key] = $event;
                            },
                            ref_for: true
                          }, _objectSpread({
                            placeholder: '请选择' + elItem.label
                          }, elItem.props || {}), {
                            type: "date"
                          }), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).DATETIME_PICKER ? (_openBlock(), _createBlock(_component_el_date_picker, _mergeProps({
                            key: 8,
                            class: "full",
                            modelValue: _unref(formData)[elItem.key],
                            "onUpdate:modelValue": function onUpdateModelValue($event) {
                              return _unref(formData)[elItem.key] = $event;
                            },
                            ref_for: true
                          }, _objectSpread({
                            placeholder: '请选择' + elItem.label
                          }, elItem.props || {}), {
                            type: "datetime"
                          }), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).INPUT_NUMBER ? (_openBlock(), _createBlock(_component_el_input_number, _mergeProps({
                            key: 9,
                            class: "full",
                            modelValue: _unref(formData)[elItem.key],
                            "onUpdate:modelValue": function onUpdateModelValue($event) {
                              return _unref(formData)[elItem.key] = $event;
                            },
                            ref_for: true
                          }, _objectSpread({
                            placeholder: '请输入' + elItem.label
                          }, elItem.props || {})), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).RADIO ? (_openBlock(), _createBlock(_component_el_radio_group, _mergeProps({
                            key: 10,
                            modelValue: _unref(formData)[elItem.key],
                            "onUpdate:modelValue": function onUpdateModelValue($event) {
                              return _unref(formData)[elItem.key] = $event;
                            },
                            ref_for: true
                          }, elItem.props || {}), {
                            default: _withCtx(function () {
                              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elItem.options || [], function (option) {
                                return _openBlock(), _createBlock(_component_el_radio, {
                                  key: option[elItem.labelKey || 'value'],
                                  label: option[elItem.valueKey || 'value']
                                }, {
                                  default: _withCtx(function () {
                                    return [_createTextVNode(_toDisplayString(option[elItem.labelKey || 'label']), 1)];
                                  }),
                                  _: 2
                                }, 1032, ["label"]);
                              }), 128))];
                            }),
                            _: 2
                          }, 1040, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).RADIO_BUTTON ? (_openBlock(), _createBlock(_component_el_radio_group, _mergeProps({
                            key: 11,
                            modelValue: _unref(formData)[elItem.key],
                            "onUpdate:modelValue": function onUpdateModelValue($event) {
                              return _unref(formData)[elItem.key] = $event;
                            },
                            ref_for: true
                          }, elItem.props || {}), {
                            default: _withCtx(function () {
                              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elItem.options || [], function (option) {
                                return _openBlock(), _createBlock(_component_el_radio_button, {
                                  key: option[elItem.labelKey || 'value'],
                                  label: option[elItem.valueKey || 'value']
                                }, {
                                  default: _withCtx(function () {
                                    return [_createTextVNode(_toDisplayString(option[elItem.labelKey || 'label']), 1)];
                                  }),
                                  _: 2
                                }, 1032, ["label"]);
                              }), 128))];
                            }),
                            _: 2
                          }, 1040, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).RATE ? (_openBlock(), _createBlock(_component_el_rate, _mergeProps({
                            key: 12,
                            modelValue: _unref(formData)[elItem.key],
                            "onUpdate:modelValue": function onUpdateModelValue($event) {
                              return _unref(formData)[elItem.key] = $event;
                            },
                            ref_for: true
                          }, elItem.props || {}), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).VIRTUALIZED_SELECT ? (_openBlock(), _createBlock(_component_el_select_v2, _mergeProps({
                            key: 13,
                            class: "full",
                            modelValue: _unref(formData)[elItem.key],
                            "onUpdate:modelValue": function onUpdateModelValue($event) {
                              return _unref(formData)[elItem.key] = $event;
                            },
                            options: getVirtualizedSelectOptions(elItem.options || [], elItem.labelKey || 'label', elItem.valueKey || 'value'),
                            ref_for: true
                          }, _objectSpread({
                            placeholder: '请选择' + elItem.label
                          }, elItem.props || {})), null, 16, ["modelValue", "onUpdate:modelValue", "options"])) : elItem.el === _unref(FORM_ITEM).SLIDER ? (_openBlock(), _createBlock(_component_el_slider, _mergeProps({
                            key: 14,
                            class: "full",
                            modelValue: _unref(formData)[elItem.key],
                            "onUpdate:modelValue": function onUpdateModelValue($event) {
                              return _unref(formData)[elItem.key] = $event;
                            },
                            ref_for: true
                          }, elItem.props || {}), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).SWITCH ? (_openBlock(), _createBlock(_component_el_switch, _mergeProps({
                            key: 15,
                            modelValue: _unref(formData)[elItem.key],
                            "onUpdate:modelValue": function onUpdateModelValue($event) {
                              return _unref(formData)[elItem.key] = $event;
                            },
                            ref_for: true
                          }, elItem.props || {}), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).TIME_PICKER ? (_openBlock(), _createBlock(_component_el_time_picker, _mergeProps({
                            key: 16,
                            class: "full",
                            modelValue: _unref(formData)[elItem.key],
                            "onUpdate:modelValue": function onUpdateModelValue($event) {
                              return _unref(formData)[elItem.key] = $event;
                            },
                            ref_for: true
                          }, _objectSpread({
                            placeholder: '请选择' + elItem.label
                          }, elItem.props || {})), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).TIME_SELECT ? (_openBlock(), _createBlock(_component_el_time_select, _mergeProps({
                            key: 17,
                            class: "full",
                            modelValue: _unref(formData)[elItem.key],
                            "onUpdate:modelValue": function onUpdateModelValue($event) {
                              return _unref(formData)[elItem.key] = $event;
                            },
                            ref_for: true
                          }, _objectSpread({
                            placeholder: '请选择' + elItem.label
                          }, elItem.props || {})), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).TRANSFER ? (_openBlock(), _createBlock(_component_el_transfer, _mergeProps({
                            key: 18,
                            modelValue: _unref(formData)[elItem.key],
                            "onUpdate:modelValue": function onUpdateModelValue($event) {
                              return _unref(formData)[elItem.key] = $event;
                            },
                            ref_for: true
                          }, elItem.props || {}), null, 16, ["modelValue", "onUpdate:modelValue"])) : elItem.el === _unref(FORM_ITEM).UPLOAD ? (_openBlock(), _createBlock(_component_el_upload, _mergeProps({
                            key: 19,
                            ref_for: true
                          }, elItem.props || {}, {
                            class: "avatar-uploader",
                            "before-upload": function beforeUpload(e) {
                              return _beforeUpload(e, elItem.key);
                            },
                            accept: ".gif,.jpg,.jpeg,.png,.GIF,.JPG,.PNG"
                          }), {
                            default: _withCtx(function () {
                              return [_unref(formData)[elItem.key] ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                style: {
                                  "width": "100%",
                                  "height": "100%",
                                  "object-fit": "cover"
                                },
                                src: _unref(formData)[elItem.key],
                                class: "avatar"
                              }, null, 8, _hoisted_1)) : (_openBlock(), _createBlock(_component_el_icon, {
                                key: 1,
                                class: "avatar-uploader-icon"
                              }, {
                                default: _withCtx(function () {
                                  return [_createVNode(_unref(Plus))];
                                }),
                                _: 1
                              }))];
                            }),
                            _: 2
                          }, 1040, ["before-upload"])) : typeof elItem.el === 'function' ? (_openBlock(), _createBlock(_resolveDynamicComponent(renderCustomItem(elItem.el)), _mergeProps({
                            key: 20,
                            class: "full",
                            ref_for: true
                          }, elItem.props || {}), null, 16)) : (_openBlock(), _createBlock(_resolveDynamicComponent(elItem.el), _mergeProps({
                            key: 21,
                            class: "full",
                            modelValue: _unref(formData)[elItem.key],
                            "onUpdate:modelValue": function onUpdateModelValue($event) {
                              return _unref(formData)[elItem.key] = $event;
                            },
                            ref_for: true
                          }, elItem.props || {}), null, 16, ["modelValue", "onUpdate:modelValue"]))];
                        }),
                        _: 2
                      }, 1032, ["label", "prop"])];
                    }),
                    _: 2
                  }, 1032, ["span"])) : _createCommentVNode("", true)], 64);
                }), 128))];
              }),
              _: 2
            }, 1024)) : _createCommentVNode("", true)], 64);
          }), 128))];
        }),
        _: 1
      }, 16, ["model"])), [[_directive_loading, _unref(loading)]]);
    };
  }
});